import auditTrailFiltersSignal, {
	setAuditTrailFilters,
} from '@UI/Pages/Administration/AuditTrail/Filters/Signals/auditTrailFiltersSignal';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { MultiSelect } from '@verclam/ui-kit';

type Props = {
	readonly options: readonly { readonly value: string; readonly label: string }[] | null;
	readonly withLabel?: boolean;
};

const OutcomeFilter: React.FC<Props> = ({ options, withLabel = false }) => {
	const currentFilters = useSignalValue(auditTrailFiltersSignal);

	const handleChange = React.useCallback((selection: readonly string[]) => {
		setAuditTrailFilters(auditTrailFiltersSignal.peek().setOutcome(selection));
	}, []);

	return (
		<MultiSelect<string>
			name="auditTrailOutcome"
			label="Résultat"
			isLabelHidden={!withLabel}
			placeholder="Tous les résultats"
			options={options ?? []}
			optionLabel="label"
			optionValue="value"
			loading={options === null}
			value={currentFilters.outcome}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default OutcomeFilter;
